import { Box, Flex, Text, Image, Container, VStack } from "@chakra-ui/react";
import React from "react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);


const EmojiList = () => {
    return (
        <Container maxW="2xl" px={6}>
            <VStack spacing={4} align="flex-start">
                <MotionBox
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 1.0, duration: 0.8 }}
                >
                    <Flex align="center" justify="start" gap={3}>
                        <Image
                            src="/eye-roll-emoji.png"
                            alt="Eye roll emoji"
                            boxSize={{ base: "1.2rem", md: "1.8rem" }}
                            minW={{ base: "1.2rem", md: "1.8rem" }}
                        />
                        <Text
                            fontSize={{ base: "sm", md: "md" }}
                            fontWeight="500"
                            lineHeight="1.4"
                            color="white"
                        >
                            Our AI won't build you an "app for anything."
                        </Text>
                    </Flex>
                </MotionBox>

                <MotionBox
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 2.0, duration: 0.8 }}
                >
                    <Flex align="center" justify="start" gap={3}>
                        <Image
                            src="/robot-emoji.png"
                            alt="Robot emoji"
                            boxSize={{ base: "1.2rem", md: "1.8rem" }}
                            minW={{ base: "1.2rem", md: "1.8rem" }}
                        />
                        <Text
                            fontSize={{ base: "sm", md: "md" }}
                            fontWeight="500"
                            lineHeight="1.4"
                            color="white"
                        >
                            It won't give you code to install, or make you talk to a chatbot to debug it.
                        </Text>
                    </Flex>
                </MotionBox>

                <MotionBox
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 3.0, duration: 1.2 }}
                >
                    <Flex align="center" justify="start" gap={3}>
                        <Image
                            src="/rocket-emoji.png"
                            alt="Rocket emoji"
                            boxSize={{ base: "1.2rem", md: "1.8rem" }}
                            minW={{ base: "1.2rem", md: "1.8rem" }}
                        />
                        <Text
                            fontSize={{ base: "sm", md: "md" }}
                            fontWeight="500"
                            lineHeight="1.4"
                            color="white"
                        >
                            It just builds you a{" "}
                            <Text as="strong" fontWeight="700">
                                real business
                            </Text>
                            , ready to serve your audience on Day 1.
                        </Text>
                    </Flex>
                </MotionBox>
            </VStack>
        </Container>
    );
}

export default EmojiList;